import { createStructuredSelector } from 'reselect';

const emotionSettingConfigStore = state => state.emotionDataStore && state.emotionDataStore.emotionSettingConfig;

const emotionSettingConfigSelector = createStructuredSelector({
  emotionSettingConfig: emotionSettingConfigStore
});

export { emotionSettingConfigSelector };
